type TermsSectionProps = {
  title: string
  number: number
  children: React.ReactNode
}

const TermsSection = ({ title, number, children }: TermsSectionProps) => {
  return (
    <div className="flex flex-col gap-y-2">
      <h3 className="inline-flex items-center gap-x-2 text-body-bold">
        <span>第{number}条</span>
        <span>{title}</span>
      </h3>
      {children}
    </div>
  )
}

export const TermsContent = () => {
  return (
    <div className="flex flex-col gap-y-10 text-body">
      <p>
        「Office
        Map」（以下「当サイト」といいます）のご利用においては、当サイトの利用規約（以下「当規約」といいます）をご承認いただく必要があります。当規約には、当サイトを通じて提供される各種サービス（以下「当サービス」といいます）の内容のほかに、株式会社トランスリアル（以下「弊社」といいます）が業務委託契約等を締結した会社その他各種事業者（以下「提携事業者」といいます）等についても記載されておりますので、内容をご理解の上、ご承認していただきますようお願い申し上げます。
      </p>

      <TermsSection number={1} title="定義">
        <p>
          弊社は、弊社が運営、提供する当サイトを通じて提供される各種サービス（以下「当サービス」といいます）の利用に関し、以下のとおり当規約を定めます。
        </p>
        <p>
          当サービスの利用者（以下「利用者」といいます）は、あらかじめ当規約に同意の上、当サービスを利用するものとします。
        </p>
      </TermsSection>

      <TermsSection number={2} title="適用範囲">
        <p>
          当規約は、利用者がWebサイトおよびその他の手段を用いて当サービスを利用した場合に適用されます。
        </p>
      </TermsSection>

      <TermsSection number={3} title="当サービスの内容">
        <p>
          オフィスに関する情報提供及び提案、提携事業者に対する問合せ、内覧申込、並びに事業運営関連情報の提供サービスとなります。
        </p>
      </TermsSection>

      <TermsSection number={4} title="提供する情報の内容">
        <div className="flex flex-col gap-y-2">
          <p>
            1.
            弊社は、当サービスにおいて提供する情報の内容に関する正確性、適時性、妥当性、適法性、有用性及びその他一切の事項について保証せず、利用者がこれらの情報により、いかなる損害・損失を被った場合でも、一切の責任を負わないものとします。そのため、当サービスにおいて提供する一切の情報の最終的な内容確認、選択、判断は、利用者の責任により行うものとし、提携事業者が提供する情報については当該提携事業者に直接確認等を行っていただくものとします。
          </p>
          <p>
            2.
            当サービスにおいて提供する情報の内容の一部または全部は、利用者に対して予告なく変更、中断または停止する場合があります。
          </p>
        </div>
      </TermsSection>

      <TermsSection number={5} title="契約の締結">
        <div className="flex flex-col gap-y-2">
          <p>
            1.
            提携事業者との契約の締結は、利用者がご検討された上で、利用者と提携事業者との間で直接行うものとします。
          </p>
          <p>
            2.
            弊社は、利用者と提携事業者との間で締結される契約等の当事者または代理人にはなりません。また、利用者、提携事業者のいずれに対しても、契約の締結の媒介を行うものではありません。
          </p>
          <p>
            3.
            提携事業者との契約の内容に関しては、提携事業者から提供される情報が、当サービスにおいて提供される情報より優先されます。利用者は、提携事業者から提示された商品・サービス内容や条件を十分にご理解の上、取引を行うようにしてください。
          </p>
          <p>
            4.
            弊社は、利用者に対し、提携事業者との契約の締結または更新、更改等の可否、これらの時期または内容等について保証いたしません。
          </p>
          <p>
            5.
            提携事業者と利用者との契約の成否、内容または履行等に関し、弊社は一切の責任を負わないものとし、提携事業者と利用者との間で解決していただくものとなります。
          </p>
        </div>
      </TermsSection>

      <TermsSection number={6} title="免責事項">
        <div className="flex flex-col gap-y-2">
          <p>
            1.
            サービスの提供、または当サービスの変更、遅延、中止、廃止その他当サービスに関わり利用者または第三者が損害を被った場合でも、弊社に故意又は重過失がない限り、弊社は一切の責任を負わないものとします。利用者はこれを承認の上、自己の責任において当サービスを利用するものとします。
          </p>
          <p>
            2.
            弊社は、利用者の個人情報を扱う場合には、SSL（SecureSocketsLayer）など暗号化通信、その他適切な方法を用いて取り扱うものとし、第三者からの不正なアクセス・使用および漏洩・改ざんから利用者の個人情報を守るよう細心の注意を払い保護します。ただし、万が一情報が第三者から不正にアクセス・使用および漏洩・改ざんされた場合であっても、弊社に故意又は重過失がない限り、弊社は一切の責任を負わないものとします。
          </p>
          <p>
            3.
            いかなる場合であろうとも、提携事業者と利用者との間での行為については、弊社は利用者に対し一切の責任を負わないものとします。
          </p>
        </div>
      </TermsSection>

      <TermsSection number={7} title="禁止事項">
        <p>
          利用者は、当サービスにおいて、以下各号に該当する行為、または以下各号に該当するとみなされる行為を行ってはならないものとします。
        </p>
        <div className="flex flex-col gap-y-2">
          <p>
            1.
            当サービス利用時の個人情報入力欄に虚偽の事実、実在する第三者の情報、または架空の情報を入力する行為
          </p>
          <p>2. 当サービスの利用により、第三者に迷惑、不利益を与える行為</p>
          <p>
            3.
            有害なコンピュータープログラム等を送信、または書き込む等、当サービスおよび弊社の他のグループサービスの運営を妨害する、または支障をきたすおそれがある行為
          </p>
          <p>4. 当サービスを営利目的で利用する行為</p>
          <p>5. 公序良俗に反する行為</p>
          <p>6. 法令及び当規約に違反する行為</p>
          <p>7. 当サービスの信用を失墜、毀損させる行為</p>
          <p>8. その他、当サービスの不正利用とみなされる行為</p>
        </div>
      </TermsSection>

      <TermsSection number={8} title="特定利用者の利用禁止">
        <p>
          弊社は、特定の利用者が当サービスの利用において次の各号に該当すると判断した場合には、当該利用者による当サービスの利用停止をすることができるものとします。これにより当該利用者に何らかの損害が生じたとしても弊社は一切の責任を負わないものとします。
        </p>
        <ul className="list-disc pl-4">
          <li>第7条の禁止事項に抵触した場合</li>
          <li>その他、弊社が利用者として不適当と判断した場合</li>
        </ul>
      </TermsSection>

      <TermsSection number={9} title="当サイトの一時中断・停止">
        <div className="flex flex-col gap-y-2">
          <div>
            <p>
              1.
              弊社は、次の各号に該当する場合には、利用者に事前に連絡することなく一時的に当サイトの一部若しくは全部を中断・停止することがあります。
            </p>
            <p>
              ①
              当サイトのメンテナンス、システムの保守、点検、修理、変更を定期的にまたは緊急に行う場合
            </p>
            <p>② 当サイト用設備に障害が発生し、やむを得ない場合</p>
            <p>
              ③
              第一種電気通信事業者またはその他の電気通信事業者の提供する電気通信役務に起因して電気通信サービスの利用が不能になった場合
            </p>
            <p>
              ④
              火災、停電などや、地震、噴火、洪水、津波などの天災により、当サイトの提供が困難な場合
            </p>
            <p>
              ⑤
              戦争、変乱、暴動、争乱、労働争議などにより当サイトの提供ができなくなった場合
            </p>
            <p>
              ⑥
              第三者による当サイトのシステムの破壊や妨害行為(データやソースコードの改ざん・破壊を含みます)などにより運営ができなくなった場合
            </p>
            <p>
              ⑦
              その他、運用上または技術上、弊社が当サイトの一時的な中断・停止を必要と判断した場合
            </p>
          </div>
          <p>
            2.
            弊社は、その事業上の必要により、利用者に事前に連絡することなく、当サイトの全部または一部の提供を中止することがあります。
          </p>
        </div>
      </TermsSection>

      <TermsSection number={10} title="当サービスの終了">
        <p>
          1.
          弊社は、相当の周知期間をもって当サイト上で掲示する方法により、利用者に対する当サイト及び当サービスの一部を終了することができるものとします。
        </p>
        <p>
          2.
          前項の掲示を行った上で当サービスを終了した場合、弊社は、利用者に対して、当サービスの終了に伴う損害、損失、その他の費用の賠償または補償を免れるものとします。
        </p>
      </TermsSection>

      <TermsSection number={11} title="知的財産権">
        <p>
          弊社が本サイトで提供する情報（映像・音声・文章・写真・ソフトウェアを含みます）に関する著作権、商標権、特許権その他の知的財産権は、すべて弊社または弊社に使用を許諾する第三者に帰属するものとし、当該知的財産権を有する弊社または第三者は、本サイト上の限定された範囲内でのみその使用を許諾するものとし、利用者は、当該範囲でのみ当該知的財産権を使用するものとします。
        </p>
      </TermsSection>

      <TermsSection number={12} title="損害賠償の請求">
        <p>
          利用者が当規約に反した行為または故意若しくは過失で当サービスを利用することにより、弊社に損害を与えた場合、当該利用者は、弊社に対して、一切の損害
          (合理的な弁護士費用を含みます) を直ちに賠償するものとします。
        </p>
      </TermsSection>

      <TermsSection number={13} title="当規約の変更">
        <p>
          弊社は、当規約を予告なく変更する場合があります。この場合、その後の当サービスの利用については、変更後の規約が適用されるものとします。
        </p>
      </TermsSection>

      <TermsSection number={14} title="反社会的勢力の排除">
        <div className="flex flex-col gap-y-2">
          <div>
            <p className="pb-2">
              1.
              利用者は、次の各号の事項について、現在及び将来にわたって確約し保証します。
            </p>
            <p>
              ①
              自らが、反社会的勢力（暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団、その他これに準ずる者をいいます。以下同じ。）ではないこと
            </p>
            <p>
              ②
              自らの役員（業務を執行する社員、取締役、執行役またはこれらに準ずる者をいいます）及び従業員が反社会的勢力ではないこと
            </p>
            <p>
              ③
              反社会的勢力に自己の名義を利用させ、当サービスを利用するものでないこと
            </p>
            <p>④ 反社会的勢力が経営を支配していないこと</p>
            <p>⑤ 反社会的勢力が経営に実質的に関与していないこと</p>
            <p>
              ⑥
              反社会的勢力に対して資金等を提供し、または便宜を供与する等の関与をしていないこと
            </p>
            <p>⑦ その他反社会的勢力と一切の関係を有していないこと</p>
            <p>
              ⑧
              反社会的勢力の排除に関連する法令、ガイドライン等に違反していないこと
            </p>
          </div>

          <div>
            <p className="pb-2">
              2.
              利用者は、自らまたは第三者を利用して次の各号のいずれか一にでも該当する行為を行わないことを、現在及び将来にわたって確約し保証します。
            </p>
            <p>① 暴力的な要求行為</p>
            <p>② 法的的な責任を超えた不当な要求行為</p>
            <p>③ 取引に関して、脅迫的な言動をし、または暴力を用いる行為</p>
            <p>
              ④
              風説を流布し、偽計または威力を用いて相手方の信用を毀損し、または相手方の業務を妨害する行為
            </p>
            <p>⑤ その他前各号に準ずる行為</p>
          </div>

          <div>
            <p>
              3.
              利用者が、前各項のいずれかに違反した場合、弊社は何らの催告を要さずに、当サービスの提供を停止することができます。
            </p>
          </div>

          <div>
            <p>
              4.
              利用者が当規約の規定により当サービスの利用を停止された場合、利用者に損害が生じても弊社は何らこれを賠償または補償することは要せず、また、解除により弊社に損害が生じた場合は、利用者はその損害を賠償するものとします。
            </p>
          </div>
        </div>
      </TermsSection>

      <TermsSection number={15} title="準拠法・管轄">
        <p>
          １.
          当規約の成立、解釈および履行並びに当サービスの提供および利用に関しては、日本法が適用されるものとします。
        </p>
        <p>
          ２.
          当規約または当サービスに関して生じた紛争については、その訴額に応じて、東京地方裁判所又は東京簡易裁判所を管轄裁判所とします。
        </p>
        <p>株式会社トランスリアル</p>
        <p>2024年10月1日 制定</p>
      </TermsSection>
    </div>
  )
}
